import React, { useState, useMemo, useCallback } from "react";
import { PortfolioGrid } from "./PortfolioGrid";
import { PortfolioSummary } from "./PortfolioSummary";
import { DiversityChart } from "./DiversityChart";
import { useTransactions } from "../../lib/useTransactions";
import { computeAllHoldingMetrics } from "../../lib/portfolioMetrics";
import { useFxRates, getBaseCurrency, setBaseCurrency } from "../../lib/fx";

export default function PortfolioMain() {
  const { transactions } = useTransactions();
  const [rows, setRows] = useState([]);
  const [base, setBase] = useState(getBaseCurrency);
  const { fx } = useFxRates(base);

  const metrics = useMemo(
    () => (transactions ? computeAllHoldingMetrics(transactions) : {}),
    [transactions]
  );

  const handleRowsChange = useCallback((nextRows) => setRows(nextRows), []);

  const handleBaseChange = useCallback((next) => {
    setBaseCurrency(next);
    setBase(next);
  }, []);

  return (
    <div className="container main-content">
      <PortfolioSummary
        rows={rows}
        metricsByTicker={metrics}
        fx={fx}
        base={base}
        onBaseChange={handleBaseChange}
      />
      <DiversityChart rows={rows} />
      <PortfolioGrid metrics={metrics} fx={fx} onRowsChange={handleRowsChange} />
    </div>
  );
}
